import { render } from "./InventoryTabs.vue?vue&type=template&id=172a4d28"
import script from "./InventoryTabs.vue?vue&type=script&lang=js"
export * from "./InventoryTabs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__